import { ethers, utils, Wallet } from 'ethers';

import { omit } from './helpers';

export const ethersProvider = () => {
  try {
    return new ethers.providers.Web3Provider(window.ethereum);
  } catch (error) {
    console.log(error);
  }
};

export const getSigner = () => {
  if (ethersProvider()) {
    return ethersProvider().getSigner();
  }
  return null;
};

export const getAddressFromSigner = async () => {
  if (getSigner()) {
    console.log('SIGNER HERE, CHECK AM OOOO', getSigner().getAddress());
    return await getSigner().getAddress();
  }
  return null;
};

export const signedTypeData = (domain, types, value) => {
  const signer = getSigner();
  // remove the __typedname from the signature!
  return signer._signTypedData(
    omit(domain, '__typename'),
    omit(types, '__typename'),
    omit(value, '__typename')
  );
};

export const splitSignature = signature => {
  return utils.splitSignature(signature);
};
